const accessoiresCharpente = [
  {
    id: "bavette",
    title: "Bavette",
    image: "/assets/images/products/Bavette.webp",
    description: "Profilé métallique d'étanchéité pour couvertures et bardages",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de bavettes.",
    category: "accessoires_charpente",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Développé: adapté à vos besoins",
      "Matériaux: acier galvanisé ou prélaqué",
      "Pliage sur mesure selon profils",
      "Fixation par vis autoperceuses ou rivets"
    ]
  },
  {
    id: "caillebotis",
    title: "Caillebotis",
    image: "/assets/images/products/Caillebotis.webp",
    description: "Grilles métalliques pour planchers industriels et passerelles",
    longDescription: "Nos caillebotis sont soumis à plusieurs contrôles afin de garantir une bonne qualité uniforme et constante. Service sur-mesure.",
    category: "accessoires_charpente",
    specifications: [
      "Types: pressés, électroforgés ou soudés",
      "Mailles: 30x30mm à 100x50mm",
      "Hauteur des barres porteuses: 20 à 70mm",
      "Matériaux: acier galvanisé, inoxydable ou aluminium",
      "Finitions: brute, galvanisée à chaud ou peinte"
    ]
  },
  {
    id: "cheneaux",
    title: "Chéneaux",
    image: "/assets/images/products/Chéneaux.webp",
    description: "Gouttières pour collecte et évacuation des eaux de pluie",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de chéneaux.",
    category: "accessoires_charpente",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Épaisseur et dimensions adaptées à vos besoins",
      "Matériaux: acier galvanisé, prélaqué ou inoxydable",
      "Accessoires: naissances, joints de dilatation, supports",
      "Fabrication standard ou sur mesure"
    ]
  },
  {
    id: "faitiere",
    title: "Faîtière",
    image: "/assets/images/products/Faîtière.webp",
    description: "Élément de jonction et d'étanchéité pour sommet de toiture",
    longDescription: "SAN METAL BY BEN AMOR, vous propose une large gamme de Faitière.",
    category: "accessoires_charpente",
    specifications: [
      "Pour toute demande spécifique, consulter l'équipe technico-commerciale",
      "Dimensions adaptées à vos besoins",
      "Matériaux: acier galvanisé ou prélaqué",
      "Formes: angulaire, ronde ou sur mesure",
      "Fixation: vis avec rondelles d'étanchéité"
    ]
  }
  // Products removed: Flasque, Glissière, Guide Portail (no images in catalog)
];

export default accessoiresCharpente;
